


















import Vue from 'vue';
export default Vue.extend({
  name: 'accounts',
  props: {
    alerts: {
      type: Array as () => any[],
      default: () => [],
    },
  },
});
